var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconL-print",
    x: 0.146,
    y: 0.865,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.945,7.639l-1.195,-0l0,-3.208c0,-0.313 -0.253,-0.566 -0.566,-0.566l-12.075,0c-0.313,0 -0.566,0.253 -0.567,0.566l0,3.208l-1.194,-0c-1.214,-0 -2.202,0.931 -2.202,2.075l0,7.547c0,0.313 0.254,0.566 0.566,0.566l2.83,0l0,4.472c0.001,0.313 0.254,0.566 0.567,0.566l12.075,0c0.313,0 0.566,-0.253 0.566,-0.566l0,-4.472l2.83,0c0.313,0 0.566,-0.253 0.566,-0.566l0,-7.547c0,-1.144 -0.987,-2.075 -2.201,-2.075Zm-13.27,-2.642l10.943,0l-0,2.642l-10.943,-0l-0,-2.642Zm10.943,16.736l-10.943,-0l-0,-6.17l10.943,0l-0,6.17Zm3.396,-5.038l-2.264,0l0,-1.698c0,-0.313 -0.253,-0.566 -0.566,-0.566l-12.075,0c-0.313,0 -0.566,0.253 -0.567,0.566l0,1.698l-2.264,0l0,-6.981c0,-0.52 0.48,-0.943 1.07,-0.943l15.597,-0c0.59,-0 1.069,0.423 1.069,0.943l0,6.981Zm-2.263,-5.094c-0,0.521 -0.423,0.943 -0.944,0.943c-0.521,0 -0.943,-0.422 -0.943,-0.943c-0,-0.521 0.422,-0.944 0.943,-0.944c0.521,0.001 0.943,0.423 0.944,0.944l-0,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLPrint);
export default __webpack_public_path__ + "static/media/iconL-print.7d897f8cfb6ae2ca55bdbc0093c8702a.svg";
export { ForwardRef as ReactComponent };